import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for list item style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiListItemStyle = (theme: Theme): ThemeStyle => {
  return {
    root: {
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
      },
    },
    button: {
      '&:hover': {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
      },
    },
  };
};
